import { render, staticRenderFns } from "./ShizhengItemList.vue?vue&type=template&id=0fee1359&"
import script from "./ShizhengItemList.vue?vue&type=script&lang=js&"
export * from "./ShizhengItemList.vue?vue&type=script&lang=js&"
import style0 from "./ShizhengItemList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports